export default __webpack_public_path__ + "static/media/logo-black.88c215ef.svg";